import { useCallback, useRef } from "react";
import { useMutation } from "@tanstack/react-query";
import { doPost, doPut } from "../common/fetchServices";

const STIP_BASE_URL = process.env.REACT_APP_STIP_BASE_URL;

const getUploadRequestUrl = () => `${STIP_BASE_URL}/file-upload/request`;

export const useRequestUploadUrl = () => {
  return useMutation(fileData => {
    const url = getUploadRequestUrl();
    return doPost(url, fileData);
  });
};

export const useUploadFile = () => {
  const abortControllerRef = useRef(null);
  const mutation = useMutation(
    ({ uploadUrl, fileBlob, progressEventHandler }) => {
      abortControllerRef.current = new AbortController();
      return doPut(uploadUrl, fileBlob, {
        headers: {
          "Content-Type": fileBlob.type,
          origin: document.location.origin,
        },
        signal: abortControllerRef.current.signal,
        onUploadProgress: progressEventHandler,
      });
    }
  );

  const abort = useCallback(() => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    mutation.reset();
  }, [mutation]);

  return {
    ...mutation,
    abort,
  };
};
